import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/MelodyTable/editor/melodytableeditor.tsx",
    () => import("./melodytableeditor"),
);
